// extracted by mini-css-extract-plugin
module.exports = {"match":"src-screens-Appointments-pickers-AppointmentTypePicker-AppointmentType-module__match--3GVQP"};